'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRight } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
type SectionHeaderProps = {
  title: string;
  viewAllHref?: string;
};
export default function SectionHeader(t0) {
  const $ = _c(13);
  const {
    title,
    viewAllHref: t1
  } = t0;
  const viewAllHref = t1 === undefined ? "/" : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== title) {
    t2 = <h2 className="subheader-3 lg:subheader-2 font-semibold">{title}</h2>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("worlds-landing.common.view-all");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronRight className="stroke-vive-primary-30 ml-1 size-3 transition-all duration-500 group-hover:stroke-white" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <span className="caption group flex items-center text-[#AAADB9]">{t3}{t4}</span>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5 || $[8] !== viewAllHref) {
    t6 = <Link href={viewAllHref} className="lg:hidden">{t5}</Link>;
    $[7] = t5;
    $[8] = viewAllHref;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <div className="flex items-center justify-between">{t2}{t6}</div>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}